import { useState, useContext } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ContentContext } from '../../Providers/ContentProvider';

const filterNamespaces = (query, namespaces) => {
    const searchStr = query.toLowerCase();
    if (!query) {
        return [];
    }

    const searchResults = namespaces.filter(el => el.toLowerCase().indexOf(searchStr) > -1)
        .sort((a,b) => a.toLowerCase().indexOf(searchStr) - b.toLowerCase().indexOf(searchStr));

    return searchResults.slice(0,10);
};

export default function NamespaceSearchBox({ passedNamespace, getNamespaceInfo }) {
    const { namespaces, clientName } = useContext(ContentContext);

    const [isNamespaceSearch, setIsNamespaceSearch] = useState(true);
    const [namespaceSelected, setNamespaceSelected] = useState(false);
    const [searchQuery, setSearchQuery] = useState(passedNamespace || '');

    const filteredNamespaces = filterNamespaces(searchQuery, isNamespaceSearch ? namespaces : clientName );
    const showFilterDropdown = filteredNamespaces.length >= 1 && !namespaceSelected;
    const searchQueryIsNamespace = filteredNamespaces.includes(searchQuery);
    const canGetNamespace = namespaceSelected || searchQueryIsNamespace;

    const fetchNamespaceInfo = (selectedNamespace) => {         
        setNamespaceSelected(true);
        getNamespaceInfo(selectedNamespace);
    };

    return (
        <>
            <div className='smart-panel-title'>
                <p className='pl-3 mb-0'>
                {isNamespaceSearch ? 'Namespaces' : 'Client Names'}
                <OverlayTrigger
                    placement='top'
                    overlay={
                        <Tooltip>
                            {`Enter ${isNamespaceSearch ? 'namespace' : 'client name'} to see client details`}
                        </Tooltip>
                    }>
                <i className='far fa-question-circle tooltip-icon'></i>
                </OverlayTrigger>
                </p>
                <span className='pl-3'>
                    {`Click on the ${isNamespaceSearch ? 'namespace' : 'client name'} below to see more info`}
                </span>
            </div>
            <div className='search-wrapper'>
                <form className='searchbar-container d-flex' onSubmit={(ev) => { ev.preventDefault(); fetchNamespaceInfo(searchQuery)} }>
                    <input className='form-control namespace-input' type='text' placeholder={isNamespaceSearch ? 'Namespace name' : 'Client name'} value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setNamespaceSelected(false); }} />
                    <Button className='btn btn-primary form-control namespace-input-btn' type='submit' disabled={!canGetNamespace}>Go</Button>
                </form>
                <Button variant='link' className='float-right mr-4 p-0 pr-2' onClick={() => setIsNamespaceSearch(!isNamespaceSearch)}><small>{isNamespaceSearch ? 'Client Name' : 'Namespace'}</small></Button>
                
                {showFilterDropdown && (
                    <div className='autocomplete-items'>
                        {filteredNamespaces.map((item, index) =>
                            <div key={index} onClick={() => { setSearchQuery(item); fetchNamespaceInfo(item); }} dangerouslySetInnerHTML={{ __html: item.replace(new RegExp(searchQuery, 'gi'), '<b>' + searchQuery + '</b>') }}></div>
                        )}
                    </div>
                )}
                </div>
        </>
    );
}